import { pluralize } from '@lib/utils/units';
import { Tooltip } from '@mui/material';
import React from 'react';
import css from './UsageBar.module.scss';

interface UsageBarSegment {
  label: string;
  color: string;
  value: number;
  tooltipText?: string | React.ReactElement;
}

interface UsageBarProps {
  segments: UsageBarSegment[];
  className?: string;
  height?: number;
}

export const UsageBar: React.FC<UsageBarProps> = ({ segments, className, height = 48 }) => {
  const totalValue = segments.reduce((sum, segment) => sum + segment.value, 0);

  return (
    <div className={`${css.usageBarContainer} ${className || ''}`}>
      <div className={css.usageBar} style={{ height: `${height}px` }}>
        {segments.map((segment, index) => {
          const percentage = totalValue > 0 ? (segment.value / totalValue) * 100 : 0;
          return (
            <Tooltip
              key={index}
              title={segment.tooltipText || pluralize(segment.value, 'credit')}
              placement="top"
              arrow
            >
              <div
                className={css.usageBarFill}
                style={
                  {
                    '--fillColor': segment.color,
                    '--flex': percentage.toString(),
                  } as React.CSSProperties
                }
              />
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};
